import React from 'react';
import Layout from '../components/layout';
import Pagination from '../components/Pagination';
import PostList from 'src/components/post-list/PostList';

var NewsPage = function NewsPage(props) {
  var data = props.data,
      pageContext = props.pageContext;
  var posts = data.allWpNews.edges;
  return /*#__PURE__*/React.createElement(Layout, {
    breadcrumbs: ['zinas']
  }, /*#__PURE__*/React.createElement(PostList, {
    posts: posts.map(function (x) {
      return x.node;
    }),
    itemsPerRow: 4
  }), /*#__PURE__*/React.createElement(Pagination, {
    pageContext: pageContext,
    pathPrefix: "/"
  }));
};

export default NewsPage;
export var pageQuery = "898300962";